import { render, staticRenderFns } from "./StickyNavigationMenuItem.vue?vue&type=template&id=6fa13017&scoped=true&"
import script from "./StickyNavigationMenuItem.vue?vue&type=script&lang=js&"
export * from "./StickyNavigationMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./StickyNavigationMenuItem.vue?vue&type=style&index=0&id=6fa13017&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa13017",
  null
  
)

export default component.exports